import React, { useState, useRef, useEffect, useCallback } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import DropdownProperties from "../common/DropdownProperties.jsx";
import { useGetAllProperties, GetAllAmenities } from "../../APIs/MasterAPIHelper.js";
import "./AddAmenities.css";
import { useSnackbar } from 'notistack';
import { PropertyAmenities, BaseURL, NewProperty } from "../../APIs/APIUrls.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { handleKeyPress } from "../../APIs/Helper.js";
import Pagination2 from "../common/Pagination2.jsx";


import SidebarMenu from "../../components/dashboard/SidebarMenu";
import Header2 from "../../components/headers/Header2";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Add Property Amenities || AskMeRealty - Real Estate",
  description: "AskMeRealty - Real Estate",
};

export default function AddAmenities() {

  const { enqueueSnackbar } = useSnackbar();
  const fetchAllProperties = useGetAllProperties();
  const location = useLocation();
  const navigate = useNavigate();

  const vendorid = localStorage.getItem("id") || 0;

  // Safely parse token with fallback
  let Token = null;
  try {
    const tokenStr = localStorage.getItem('tcn');
    Token = tokenStr ? JSON.parse(tokenStr) : null;
  } catch (e) {
    console.error("Error parsing token:", e);
    Token = localStorage.getItem('tcn'); // Fallback to raw token if it's not JSON
  }

  //pagination and search filter states
  const [page, setPage] = useState(1);
  const [ItemsPerPage, setItemsPerPage] = useState(10);

  //My Properties useState
  const [myProperties, setMyProperties] = useState([]);
  const [myPropertiesFilter, setMyPropertiesFilter] = useState([]);

  const [PropertyIdFilter, setPropertyIdFilter] = useState("");
  const PropertyFilterref = useRef();


  const [isDragging, setIsDragging] = useState(false); // Track drag state
  const [images, setImages] = useState([]);

  const [lstProperties, setLstProperties] = useState([]);
  const [lstPropertiesFilter, setLstPropertiesFilter] = useState([]);
  const [PropertyId, setPropertyId] = useState("");
  const Propertyref = useRef();

  const [lstAmenities, setLstAmenities] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const Amenityref = useRef();

  const [lstPropertyAmenities, setLstPropertyAmenities] = useState([]);
  const [lstPropertyAmenitiesFilter, setLstPropertyAmenitiesFilter] = useState([]);
  const [PropertyAmenityId, setPropertyAmenityId] = useState("");

  const [queryPropertyId, setQueryPropertyId] = useState("");


  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const buildPropertyOptions = (propertiesInput) => {
    const mapped = (Array.isArray(propertiesInput) ? propertiesInput : [])
      .filter((prop) => prop && prop.PropertyId != null)
      .map((prop) => ({
        PropertyGeneratedId: `${prop.PropertyGeneratedId || ""}: ${prop.PropertyTitle || ""}`.trim(),
        PropertyId: String(prop.PropertyId)
      }));

    const uniqueOptions = Array.from(new Map(mapped.map((item) => [String(item.PropertyId), item])).values());
    uniqueOptions.unshift({ PropertyGeneratedId: "Select", PropertyId: "0" });
    return uniqueOptions;
  };

  const GetPropertyAmenities = useCallback(async (propertyId) => {
    try {

      // Use provided propertyId or queryPropertyId
      const idToUse = propertyId || queryPropertyId;
      if (!idToUse || String(idToUse) === "0") {
        setLstPropertyAmenities([]);
        setLstPropertyAmenitiesFilter([]);
        return;
      }
      const tokenStr = JSON.parse(localStorage.getItem('tcn'));
      const response = await fetch(`${PropertyAmenities}GetPropertyAmenitiesByPropertyId/${idToUse}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenStr}`
        }
      });
      debugger
      if (!response.ok) {
        const err = await response.text();
        throw new Error(err || `Request failed with status ${response.status}`);
      }

      const result = await response.json();
      const list = result?.data || result || [];

      setLstPropertyAmenities(Array.isArray(list) ? list : []);
      setLstPropertyAmenitiesFilter(Array.isArray(list) ? list : []);
    } catch (error) {
      console.log('Error fetching property amenities:', error);
    }
  }, [Token, queryPropertyId]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const propertyIdFromQuery = params.get("id");
    if (propertyIdFromQuery && propertyIdFromQuery !== "0") {
      const normalizedId = String(propertyIdFromQuery);
      setQueryPropertyId(normalizedId);
      setPropertyId(normalizedId);
      setPropertyIdFilter(normalizedId);
    }

    const getDDLProperties = async () => {
      debugger
      try {
        const result = await fetchAllProperties();
        console.log('API Response:', result);
        if (result) {
          // Handle both: result.data (wrapped) and result (direct array)
          let properties = result.data || result;
          console.log('Properties array:', properties);

          if (Array.isArray(properties) && properties.length > 0) {
            const ddlOptions = buildPropertyOptions(properties);
            setLstProperties(ddlOptions);
            setLstPropertiesFilter(queryPropertyId && queryPropertyId !== "0"
              ? ddlOptions.filter((item) => String(item.PropertyId) === String(queryPropertyId) || String(item.PropertyId) === "0")
              : ddlOptions);
          }
        }
      } catch (error) {
        console.log('Error fetching properties:', error);
      }
    };

    const fetchAllAmenities = async () => {
      try {
        const result = await GetAllAmenities();
        console.log('API Response for Amenities:', result);
        if (result) {
          let amenities = result.data || result;
          console.log('Amenities array:', amenities);

          if (Array.isArray(amenities) && amenities.length > 0) {
            amenities = amenities.map(amenity => ({
              AmenityName: amenity.TypeName,
              AmenityId: amenity.TypeId
            }));
            setLstAmenities((prev) => {
              // merge but avoid duplicates
              const map = new Map(prev.map(a => [String(a.AmenityId), a]));
              amenities.forEach(a => map.set(String(a.AmenityId), a));
              return Array.from(map.values());
            });
          }
        }
      } catch (error) {
        console.log('Error fetching amenities:', error);
      }
    };



    getDDLProperties();
    fetchAllAmenities();


  }, [location.search, queryPropertyId])





  // Handlers to normalize selected item from dropdowns and store only the Ids
  const handleSelectProperty = (item) => {
    // Dropdown may return an object or simple value; prefer PropertyId if present
    const value = item?.PropertyId ?? item?.value ?? item ?? "";
    setPropertyId(String(value));
  };

  const handleToggleAmenity = (amenityId) => {
    const amenityIdStr = String(amenityId);
    setSelectedAmenities((prev) =>
      prev.includes(amenityIdStr)
        ? prev.filter((id) => id !== amenityIdStr)
        : [...prev, amenityIdStr]
    );
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!PropertyId || PropertyId === "0") {
      enqueueSnackbar("Please select a property", { variant: "warning" });
      return;
    }
    if (selectedAmenities.length === 0) {
      enqueueSnackbar("Please select at least one amenity", { variant: "warning" });
      return;
    }

    setIsLoading(true);
    try {
      // Filter out amenities that already exist in the property
      const newAmenitiesForInsert = selectedAmenities.filter((amenityId) => {
        const alreadyExists = lstPropertyAmenities.some(
          (item) =>
            item.PropertyId === parseInt(PropertyId, 10) &&
            item.MasterAmenityId === parseInt(amenityId, 10)
        );
        return !alreadyExists;
      });

      if (newAmenitiesForInsert.length === 0) {
        enqueueSnackbar("All selected amenities are already added to this property", { variant: "info" });
        setIsLoading(false);
        return;
      }

      // Build payload array matching backend structure
      const payloadArray = newAmenitiesForInsert.map((amenityId) => ({
        PropertyId: parseInt(PropertyId, 10),
        MasterAmenityId: parseInt(amenityId, 10),
        CreatedBy: parseInt(vendorid, 10),
      }));

      const headers = { "Content-Type": "application/json" };
      if (Token) {
        const tokenStr =
          typeof Token === "string"
            ? Token
            : Token.accessToken || Token.token || JSON.stringify(Token);
        headers["Authorization"] = `Bearer ${tokenStr}`;
      }

      // Send entire array in one API call
      const response = await fetch(`${PropertyAmenities}InsertPropertyAmenities`, {
        method: "POST",
        headers,
        body: JSON.stringify(payloadArray),
      });

      const result = await response.json();

      if (!response.ok || !result.isSuccess) {
        throw new Error(result?.Message || "Failed to add amenities");
      }

      // If property was from query string, keep it selected; otherwise reset
      if (queryPropertyId && queryPropertyId !== "0") {
        setPropertyId(queryPropertyId);
      } else {
        setPropertyId("0");
      }

      setSelectedAmenities([]);
      setUploadSuccess(true);

      enqueueSnackbar(
        `${newAmenitiesForInsert.length} amenity(ies) added successfully`,
        { variant: "success" }
      );

      // Refresh the property amenities list with the current/query property ID
      const refreshPropertyId = queryPropertyId && queryPropertyId !== "0" ? queryPropertyId : PropertyId;
      GetPropertyAmenities(refreshPropertyId);
      setTimeout(() => setUploadSuccess(false), 1000);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(err.message || "Failed to add amenities", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAmenities = async (amenityId) => {
    try {
      const tokenStr = typeof Token === "string" ? Token : (Token?.accessToken || Token?.token || JSON.stringify(Token));
      const headers = { "Content-Type": "application/json" };
      if (tokenStr) headers["Authorization"] = `Bearer ${tokenStr}`;
      const response = await fetch(`${PropertyAmenities}DeletePropertyAmenities/${amenityId}`, {
        method: "POST",
        headers
      });
      if (!response.ok) {
        const err = await response.text();
        throw new Error(err || `Request failed with status ${response.status}`);
      }
      enqueueSnackbar("Amenity deleted successfully", { variant: "success" });
      // Refresh the list after deletion
      const updatedList = lstPropertyAmenities.filter(item => item.AmenitiesId !== amenityId);
      setLstPropertyAmenities(updatedList);
      setLstPropertyAmenitiesFilter(updatedList);
    }
    catch (error) {
      console.log('Error deleting amenity:', error);
      enqueueSnackbar("Failed to delete amenity", { variant: "error" });
    }
  };

  // Fetch property-specific amenities when queryPropertyId changes
  useEffect(() => {
    if (queryPropertyId && queryPropertyId !== "0") {
      GetPropertyAmenities(queryPropertyId);
    }
  }, [queryPropertyId, GetPropertyAmenities]);

  useEffect(() => {

    if (queryPropertyId && queryPropertyId !== "0") {
      const filteredAmenities = lstPropertyAmenities.filter(item => String(item.PropertyId) === String(queryPropertyId));
      setLstPropertyAmenitiesFilter(filteredAmenities);
      return;
    }

    if (PropertyIdFilter && PropertyIdFilter != "0") {
      const filteredAmenities = lstPropertyAmenities.filter(item => item.PropertyId == PropertyIdFilter);
      setLstPropertyAmenitiesFilter(filteredAmenities);
    } else {
      setLstPropertyAmenitiesFilter(lstPropertyAmenities);
    }

  }, [PropertyIdFilter, queryPropertyId, lstPropertyAmenities])

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const propertyIdFromQuery = params.get("id");

    const validateQueryString = async (propertyId) => {
      if (!propertyId || propertyId === "0") {
        return;
      }

      const isNumericId = /^\d+$/.test(String(propertyId));
      if (!isNumericId) {
        enqueueSnackbar("Invalid property ID in the URL.", { variant: "error" });
        localStorage.clear();
       window.location.href = "/"; // Use full page reload to ensure all state is cleared
        return;
      }

      try {
        const tokenStr = JSON.parse(localStorage.getItem('tcn'));
        const vid = localStorage.getItem("id") || 0;

        const res = await fetch(`${NewProperty}GetNewPropertyByVendorId/${vid}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${tokenStr}`
          }
        });

        if (!res.ok) {
          throw new Error(`Request failed with status ${res.status}`);
        }

        const result = await res.json();
        const vendorProperties = Array.isArray(result?.data)
          ? result.data
          : result?.data
            ? [result.data]
            : Array.isArray(result)
              ? result
              : [];

        const isAllowed = vendorProperties.some((item) => String(item?.PropertyId) === String(propertyId));

        if (!isAllowed) {
          enqueueSnackbar(
            "Unauthorized or invalid property ID in the query string. Please check the URL.",
            { variant: "error" }
          );
          localStorage.clear();
          window.location.href = "/"; // Use full page reload to ensure all state is cleared
        }
      } catch (error) {
        console.log('Error validating query string:', error);
      }
    };

    validateQueryString(propertyIdFromQuery);
  }, [enqueueSnackbar, location.search, navigate])

  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="layout-wrap">
        <Header2 />
        <SidebarMenu />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="button-show-hide show-mb">
              <span className="body-1">Show Dashboard</span>
            </div>

            <div className="widget-box-2 mb-20">
              <h5 className="title">Add Facilities/ Amenities</h5>
              <div className="box grid-3 gap-30" >
                <fieldset className="box-fieldset">
                  <label htmlFor="country">
                    Property Name:<span>*</span>
                  </label>
                  <DropdownProperties
                    options={lstPropertiesFilter}
                    setItem={handleSelectProperty}
                    refItem={Propertyref}
                    StateValue={PropertyId}
                    disabledflag={!!queryPropertyId && queryPropertyId !== "0"}
                  />
                </fieldset>
              </div>
              <div className="box grid-12 gap-30" >
                <fieldset className="box-fieldset">
                  <label htmlFor="amenities-label">
                    Amenities Name:<span>*</span>
                  </label>
                  <div className="add-amenities-chip-list">
                    {lstAmenities.length > 0 ? (
                      lstAmenities.map((amenity) => {
                        // Check if amenity already exists in the property (from API)
                        const masterEntry = lstPropertyAmenities.find(p => String(p.MasterAmenityId) === String(amenity.AmenityId));
                        // Check if amenity is in the newly selected list
                        const isNewlySelected = selectedAmenities.includes(String(amenity.AmenityId));
                        // Show active if either already saved OR newly selected
                        const isActive = !!masterEntry || isNewlySelected;

                        return (
                          <div key={amenity.AmenityId} style={{ display: 'inline-block', marginRight: 8, marginBottom: 8 }}>
                            <button
                              type="button"
                              className={`add-amenities-chip ${isActive ? "is-active" : ""}`}
                              onClick={() => {
                                if (masterEntry) {
                                  // Amenity already exists on property - remove it
                                  if (window.confirm(`Remove ${amenity.AmenityName} from this property?`)) {
                                    handleDeleteAmenities(masterEntry.AmenitiesId);
                                  }
                                } else {
                                  // Toggle newly selected amenity (for adding)
                                  handleToggleAmenity(amenity.AmenityId);
                                }
                              }}
                              title={masterEntry ? 'Click to remove from property' : (isNewlySelected ? 'Click to deselect' : 'Click to select')}
                            >
                              {amenity.AmenityName}
                            </button>
                          </div>
                        );
                      })
                    ) : (
                      <p className="no-amenities">No amenities available</p>
                    )}
                  </div>
                  {selectedAmenities.length > 0 && (
                    <div className="selected-amenities-info">
                      <small>
                        Selected: {selectedAmenities.length} Facilities
                      </small>
                    </div>
                  )}
                </fieldset>
              </div>
            </div>

            <div className="box-btn">
              <button
                className="tf-btn primary"
                onClick={handleSubmit}
                disabled={isLoading || !PropertyId || PropertyId === "0" || selectedAmenities.length === 0}
                style={{
                  opacity: isLoading || !PropertyId || PropertyId === "0" || selectedAmenities.length === 0 ? 0.6 : 1,
                  cursor: isLoading || !PropertyId || PropertyId === "0" || selectedAmenities.length === 0 ? 'not-allowed' : 'pointer'
                }}
              >
                {isLoading && (
                  <span style={{ marginRight: '8px', display: 'inline-flex', alignItems: 'center' }}>
                    <ClipLoader size={16} color="currentColor" />
                  </span>
                )}
                {isLoading ? 'Processing...' : uploadSuccess ? 'Added ✓' : `Add ${selectedAmenities.length > 0 ? selectedAmenities.length : ''} Amenities`}
              </button>
            </div>

            {/* Table listing removed — facilities are now managed via the chips above.
                If you want to re-enable the table view, uncomment the original markup and adjust as needed. */}
          </div>
        </div>
        <div className="overlay-dashboard" />
      </div>
    </>
  );
}
